"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _DestinationUrlView = _interopRequireDefault(require("./DestinationUrlView"));

var _DestinationUrlEdit = _interopRequireDefault(require("./DestinationUrlEdit"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CommunityConfiguration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CommunityConfiguration, _Component);

  var _super = _createSuper(CommunityConfiguration);

  function CommunityConfiguration() {
    var _this;

    (0, _classCallCheck2.default)(this, CommunityConfiguration);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      currentPage: window.location.pathname.includes('/edit') ? 'edit' : 'view',
      destinationURL: _this.props.destinationURL,
      alert: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNavigateToEdit", function () {
      _this.setState({
        currentPage: 'edit'
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSave", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var destinationURL;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              destinationURL = _this.state.destinationURL;
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.post('/community/settings/save', {
                destinationURL: destinationURL
              });

            case 4:
              window.location.assign('?flush');
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              _this.setState({
                alert: {
                  type: 'error',
                  message: _context.t0.response.data
                }
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(CommunityConfiguration, [{
    key: "renderLegacyForm",
    value: function renderLegacyForm() {
      var _this2 = this;

      var _this$state = this.state,
          destinationURL = _this$state.destinationURL,
          alert = _this$state.alert;
      return (0, _preact.h)("div", {
        className: "community-settings-page"
      }, (0, _preact.h)(_header.default, {
        title: "Destination URL",
        hasBreadcrumb: false,
        saveCallback: this.onSave
      }), alert && (0, _preact.h)(_AlertComponent.default, {
        sticky: true,
        isVisible: true,
        message: alert.message,
        messageType: alert.type,
        isVisibleFor: 5000,
        onTimeoutEnd: function onTimeoutEnd() {
          return _this2.setState({
            alert: null
          });
        }
      }), (0, _preact.h)("div", {
        className: "community-settings"
      }, (0, _preact.h)(_InputGroup.default, {
        newStyle: true,
        title: "Destination URL",
        type: "text",
        onChange: function onChange(e) {
          return _this2.setState({
            destinationURL: e.target.value
          });
        },
        meta: "Change the destination URL for this community below.",
        value: destinationURL,
        placeholder: "https://community.example.com",
        required: true,
        qaClasses: "destination-url-input"
      })));
    }
  }, {
    key: "renderNewFeature",
    value: function renderNewFeature() {
      var currentPage = this.state.currentPage;
      var destinationURL = this.props.destinationURL;

      if (currentPage === 'view') {
        return (0, _preact.h)(_DestinationUrlView.default, {
          destinationURL: destinationURL,
          onNavigateToEdit: this.handleNavigateToEdit
        });
      }

      return (0, _preact.h)(_DestinationUrlEdit.default, null);
    }
  }, {
    key: "render",
    value: function render() {
      if (_common.common.isModuleActive('selfServiceCustomDomain')) {
        return this.renderNewFeature();
      }

      return this.renderLegacyForm();
    }
  }]);
  return CommunityConfiguration;
}(_preact.Component);

var _default = CommunityConfiguration;
exports.default = _default;